import { ButtonIconLabel } from '../button';
import CheckSolid from '@assets/svgs/CheckSolid.svg';

interface CheckIconTextProps {
  errorMessage: string;
}

const CheckIconText = ({ errorMessage }: CheckIconTextProps) => (
  <div className="w-[328px] ml-[-20px] px-[10px]">
    <ButtonIconLabel
      SVGIcon={CheckSolid}
      iconPosition="left"
      iconSize={'large'}
    >
      {errorMessage}
    </ButtonIconLabel>
  </div>
);
export default CheckIconText;
